/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AuthClient, AuthClient$inboundSchema } from "./authclient.js";

export type ListAuthClientsResponseBody = {
  items: Array<AuthClient>;
  nextCursor?: string | undefined;
};

/** @internal */
export const ListAuthClientsResponseBody$inboundSchema: z.ZodMiniType<
  ListAuthClientsResponseBody,
  unknown
> = z.pipe(
  z.object({
    items: z.array(AuthClient$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listAuthClientsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListAuthClientsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAuthClientsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAuthClientsResponseBody' from JSON`,
  );
}
